import TradeFilters from './TradeFilters.view';

export default TradeFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeFilters/index.js